export default "__VITE_ASSET__41b0IeFL__"